module.exports = __webpack_public_path__ + "static/media/shipsland.d34283af.png";